import { render } from "./ZhaoqingInstitution.vue?vue&type=template&id=378e1566&scoped=true"
import script from "./ZhaoqingInstitution.vue?vue&type=script&lang=js"
export * from "./ZhaoqingInstitution.vue?vue&type=script&lang=js"

import "./ZhaoqingInstitution.vue?vue&type=style&index=0&id=378e1566&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378e1566"]])

export default __exports__